import "../styles/MyHistory.css"
export const MyHistory = () => {
    return(
        <div id="my-history">
        <ul className="list-group">
            <h6 className="display-6">Eğtim Geçmişim</h6>
            <li className="list-group-item list-group-item-info">Asef Çoban Anadolu Lisesi (lise)</li>
            <li className="list-group-item list-group-item-info">Gümüşhane Üniversitesi (lisans)</li>
        </ul>
        <ul className="list-group">
            <h6 className="display-6">Sertifikalarım</h6>
            <li className="list-group-item list-group-item-info">Young Executive Academy (Yea)</li>
            <li className="list-group-item list-group-item-info">React İle Web Programcılığı</li>
            <li className="list-group-item list-group-item-info">GoLang İle Backend Api Programlama</li>
            <li className="list-group-item list-group-item-info">C# İle Otomasyon Geliştirme</li>
            <li className="list-group-item list-group-item-info">FrontEnd Web Tasarım Ve Analizi</li>
            <li className="list-group-item list-group-item-info">Javascript Ve NodeJs ile Web Uygulamaları Geliştirme</li>
            <li className="list-group-item list-group-item-info">Bootstrap 5 ile Web Geliştirme</li>
            <li className="list-group-item list-group-item-info">Redux Store ile Web Geliştirme</li>
            <li className="list-group-item list-group-item-info">Firebase ile Veritabanı Programlama</li>
            <li className="list-group-item list-group-item-info">MongoDb ile Veritabanı Programlama</li>

        </ul>
        <ul className='list-group'>
            <h6 className="display-6">Bilgi Sahibi Olduğum Yazılım Dilleri</h6>

            <li className='list-group-item list-group-item-success'>HTML</li>
            <li className='list-group-item list-group-item-primary'>CSS</li>
            <li className='list-group-item list-group-item-danger'>JAVASCRİPT</li>
            <li className='list-group-item list-group-item-warning'>C#</li>
            <li className='list-group-item list-group-item-info'>C</li>
            <li className='list-group-item list-group-item-light'>C++</li>
            <li className='list-group-item list-group-item-dark'>GO LANG</li>
            <li className='list-group-item list-group-item-primary'>REACT JS</li>
            <li className='list-group-item list-group-item-success'>REDUX</li>
            <li className='list-group-item list-group-item-danger'>BOOTSTRAP</li>
            <li className='list-group-item list-group-item-secondary'>MATERİAL Uİ</li>
            <li className='list-group-item list-group-item-success'>MONGO DATABASE</li>
            <li className='list-group-item list-group-item-info'>FİREBSAE DATABASE</li>
        </ul>



</div>
    )
}